import React from 'react';
import minusButton from '../../../img/minus-button.png';
import plusButton from '../../../img/plus-button.png';

export default class Counter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectValue : '0',
            min         : 0,
            max         : 0
        };

        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                selectValue: nextProps.currentValue,
                min: nextProps.min,
                max: nextProps.max
                });
        }
    }

    componentWillMount(){
        this.setState({
                selectValue : this.props.currentValue,
                min         : this.props.min,
                max         : this.props.max
            });
    }

    increment(e){
        let oldVal = this.state.selectValue;

        let max    = this.state.max;
        if(oldVal < max){
            this.setState({selectValue:oldVal + 1});
            this.props.callbackParent(oldVal + 1);
        }
    }

    decrement(e){
        let oldVal = this.state.selectValue;
        let min    = this.state.min;
        if (oldVal > min) {
            this.setState({selectValue:oldVal - 1});
            this.props.callbackParent(oldVal - 1);
        }
    }

    render() {
        return (
            <div className = "btn-group1 ctr" role = "group" aria-label = "...">
                <button type = "button" className = "btn counter-button btn-button-link" onClick = {this.decrement} tabIndex={0}>
                    <img src={minusButton} className="minusButton" alt={"Decrease Item Quantity"}/></button>
                <button type = "button" className = "btn btn-mid" tabIndex={-1}>{this.state.selectValue}</button>
                <button type = "button" className = "btn btn-inc counter-button btn-button-link" onClick = {this.increment} tabIndex={0}>
                    <img src={plusButton} className="plusButton" alt={"Increase Item Quantity"}/>
                </button>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// src/components/generic/counter.jsx